import React, { useEffect, useState } from "react";
import { FormSection } from "@components/FormSection/FormSection";
import { PreviewTable } from "@components/PreviewTable/PreviewTable";
import { Loading } from "@components/Loading/Loading";
import { ButtonComponent, hasValue } from "uxp/components";
import { useQueryEngineService } from "./useQueryEngineService";
import './QueryPreview.scss';
/**
 * Read-only preview of a saved query: name/description header block, a live
 * data preview table, and an optional "Edit Query" action.
 *
 * When `query` is omitted the component resolves `queryId` via the query
 * engine catalog (getQueryDataSourceById) and builds a source-only query
 * `{ sources: [ref], steps: [], sourceOnly: true }` for execution.
 */
export const QueryPreview = props => {
    var _a, _b, _c, _d;
    const { uxpContext, queryId, query, name, description, onEdit } = props;
    const services = useQueryEngineService(uxpContext);
    const [resolvedQuery, setResolvedQuery] = useState(query || null);
    const [loading, setLoading] = useState(!query);
    const $L = (key) => uxpContext.$L(key);
    useEffect(() => {
        let cancelled = false;
        if (query) {
            setResolvedQuery(query);
            setLoading(false);
            return;
        }
        if (!queryId) {
            setResolvedQuery(null);
            setLoading(false);
            return;
        }
        setLoading(true);
        services.getQueryDataSourceById(queryId).then(source => {
            if (cancelled)
                return;
            setResolvedQuery(source ? {
                sources: [source],
                steps: [],
                sourceOnly: true
            } : null);
            setLoading(false);
        }).catch(() => {
            if (cancelled)
                return;
            setResolvedQuery(null);
            setLoading(false);
        });
        return () => {
            cancelled = true;
        };
    }, [queryId, query]);
    const displayName = hasValue(name) ? name : ((_b = (_a = resolvedQuery === null || resolvedQuery === void 0 ? void 0 : resolvedQuery.sources) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.name) || '';
    const displayDescription = hasValue(description) ? description : ((_d = (_c = resolvedQuery === null || resolvedQuery === void 0 ? void 0 : resolvedQuery.sources) === null || _c === void 0 ? void 0 : _c[0]) === null || _d === void 0 ? void 0 : _d.description) || '';
    return React.createElement("div", { className: "lqe-qp-b6ddb674" },
        React.createElement("div", { className: "lqe-qp__header-b6ddb674" },
            React.createElement("div", { className: "lqe-qp__details-b6ddb674" },
                React.createElement(FormSection, { label: $L('lqe.common.name') },
                    React.createElement("div", { className: "lqe-qp__ro-val-b6ddb674" }, displayName)),
                hasValue(displayDescription) && React.createElement(FormSection, { label: $L('lqe.common.description') },
                    React.createElement("div", { className: "lqe-qp__ro-val-b6ddb674" }, displayDescription))),
            onEdit && React.createElement("div", { className: "lqe-qp__header-actions-b6ddb674" },
                React.createElement(ButtonComponent, { title: $L('lqe.qe.edit-query'), leftIcon: "fas pencil", onClick: onEdit, variant: "secondary", size: "small" }))),
        React.createElement("div", { className: "lqe-qp__preview-b6ddb674" }, loading ? React.createElement(Loading, null) : resolvedQuery ? React.createElement(PreviewTable, { query: resolvedQuery, uxpContext: uxpContext }) : React.createElement("div", { className: "lqe-qp__empty-b6ddb674" }, $L('lqe.qp.no-data'))));
};
export default QueryPreview;
